import {
  Grid,
  makeStyles,
} from '@material-ui/core';
import React, {useEffect, useRef, useState} from 'react';
import {useHistory} from 'react-router-dom';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import {TrafficShapingService} from "../../../Domain/Services/TrafficShapingService";
import CubeMatchingEntry from "../../../Domain/Models/CubeMatchingEntry";
import GroupElement from "./GroupElement";
import {TrafficShapingStatus} from "../../../Domain/Models/TrafficShapingStatus";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
}));

interface WaitingAreaProps
{
  trafficShapingStatus: TrafficShapingStatus;
}

export default function WaitingArea(props: WaitingAreaProps)
{
  const classes = useStyles();
  const history = useHistory();

  const { trafficShapingStatus } = props;

  const getOrderedQueue = (): CubeMatchingEntry[] =>
  {
    return trafficShapingStatus.cubeMatchingEntries
      .sort((a, b) =>
        Number(a.matchedCube === undefined) - Number(b.matchedCube === undefined))
  }

  return (
    <>
      <Grid container>
        {getOrderedQueue().map(x => (
          <Grid item xs={12} sm={6} md={4}>
            <GroupElement group={x.group} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}